import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./header.style.css";
// import { Dropdown } from "react-bootstrap";
import AppConfig from "../../config/app.config";
import { selectSigninStatus, selectSubscriptionData } from "../../store/auth/auth.selectors";
import { userSignOut, updateSubscription, updateEmployee } from "../../store/auth/auth.actions";
import { style } from "@mui/system";
import { Box, Divider, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { Button } from "@mui/material";
import { FaBars } from "react-icons/fa";
import { GoSignOut } from "react-icons/go";
import { Dropdown, ButtonToolbar } from "rsuite";

export class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDrawerOpen: false,
            employee: this.props.signinStatus.employee,
            subscription: this.props.subscriptionData.subscription,
            subscriptions: this.props.subscriptionData.subscriptions,
        };
    }

    componentDidUpdate() {
        if (this.state.employee !== this.props.signinStatus.employee) {
            this.setState({ employee: this.props.signinStatus.employee });
        }
        if (this.state.subscription !== this.props.subscriptionData.subscription) {
            this.setState({
                subscriptions: this.props.subscriptionData.subscriptions,
                subscription: this.props.subscriptionData.subscription,
            });
        }
    }

    toggleDrawer(anchor, open, event) {
        if ((anchor === "left", typeof open == "boolean")) {
            if (event.type === "click") {
                this.setState({ ...this.state, isDrawerOpen: open });
            }
        }
    }

    profileView = (props, ref) => {
        return (
            <ButtonToolbar {...props} ref={ref}>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                    }}
                >
                    <p
                        style={{
                            color: "#ffffff",
                            fontSize: "20px",
                            marginRight: "20px",
                            marginBottom: "0",
                        }}
                    >
                        {this.state.employee?.name}
                    </p>
                    <img
                        style={{
                            height: "40px",
                            width: "40px",
                            borderRadius: "28px",
                        }}
                        src={AppConfig.API.USER_PROFILE + this.state.employee?.employeeId}
                        alt="Profile"
                    />
                </div>
            </ButtonToolbar>
        );
    };

    render() {
        return (
            <div className="header" style={{ margin: 0, width: "100%" }}>
                <h1 className="headerTitle">Ciright Scan</h1>

                <div style={{ display: "flex", alignItems: "center" }}>
                    {this.props.history.location.pathname === "/verticals" && this.state.subscriptions !== null && (
                        <Dropdown
                            title={this.state.subscription.subscriptionName}
                            placement="bottomEnd"
                            className="dropVerticalContainer"
                        >
                            {this.state.subscriptions.map((sub) => {
                                return (
                                    <Dropdown.Item
                                        key={sub.subscriptionId}
                                        eventKey="1"
                                        active={
                                            this.state.subscription.subscriptionId === sub.subscriptionId ? true : false
                                        }
                                        onClick={() => {
                                            this.setState({
                                                subscription: sub,
                                            });
                                            this.props.updateSubscription({ subscription: sub });
                                        }}
                                    >
                                        {sub.subscriptionName}
                                    </Dropdown.Item>
                                );
                            })}
                        </Dropdown>
                    )}

                    {this.state.employee !== null && (
                        <>
                            <Button
                                className="buttonToggle"
                                onClick={(event) => this.toggleDrawer("left", true, event)}
                            >
                                <FaBars size={30} />
                            </Button>
                            {this.props.history.location.pathname === "/home" && (
                                <div className="dropDownContainer">
                                    <Dropdown
                                        renderToggle={this.profileView}
                                        menuStyle={{ width: "187px", marginTop: "10px" }}
                                    >
                                        <Dropdown.Item
                                            eventKey="2"
                                            onClick={() => {
                                                this.props.userSignOut();
                                                localStorage.clear();
                                                this.props.history.replace("/");
                                            }}
                                        >
                                            Sign Out
                                        </Dropdown.Item>
                                    </Dropdown>
                                </div>
                            )}

                            <Drawer
                                anchor={"left"}
                                open={this.state.isDrawerOpen}
                                onClose={(event) => this.toggleDrawer("left", false, event)}
                            >
                                <Box
                                    sx={{ width: 150 }}
                                    className="boxContainer"
                                    role="presentation"
                                    onClick={(event) => this.toggleDrawer("left", false, event)}
                                    onKeyDown={(event) => this.toggleDrawer("left", false, event)}
                                >
                                    <div style={{ backgroundColor: "#003087" }}>
                                        <Divider />
                                        <List>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    marginTop: "0.3rem",
                                                }}
                                            >
                                                <h4 style={{ color: "#ffffff", marginLeft: "0.9rem" }}>Ciright Scan</h4>
                                            </div>
                                            <ListItem key="dispalyname" disablePadding>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        <img
                                                            style={{
                                                                width: "2.3rem",
                                                                height: "2.3rem",
                                                                objectFit: "cover",
                                                                borderRadius: "50%",
                                                            }}
                                                            src={
                                                                AppConfig.API.USER_PROFILE +
                                                                this.state.employee?.employeeId
                                                            }
                                                            alt=""
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        style={{ color: "#ffffff", fontSize: "32px" }}
                                                        primary={this.state.employee?.name}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                            <Divider />
                                        </List>
                                    </div>
                                    <List>
                                        <ListItem key="signout" disablePadding>
                                            <ListItemButton
                                                onClick={() => {
                                                    this.props.userSignOut();
                                                    this.props.history.replace("/");
                                                }}
                                            >
                                                <ListItemIcon>
                                                    <GoSignOut size={30} />
                                                </ListItemIcon>
                                                <ListItemText primary={"SignOut"} />
                                            </ListItemButton>
                                        </ListItem>
                                    </List>
                                </Box>
                            </Drawer>
                        </>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        signinStatus: selectSigninStatus(state),
        subscriptionData: selectSubscriptionData(state),
    };
};

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators(
        {
            userSignOut,
            updateSubscription,
            updateEmployee,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
